import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BehaviorSubject, catchError, map, Observable, of, tap } from "rxjs";
import { BaseRespone } from "src/app/models/common.response";
import { environment } from "src/environments/environment";
import { IPayment, IPaymentList } from "./ipayment";


@Injectable({ providedIn: 'root' })
export class PaymentService {

    private _payment: BehaviorSubject<IPayment | null> = new BehaviorSubject<IPayment | null>(null);
    private _paymentlist: BehaviorSubject<IPaymentList | null> = new BehaviorSubject<IPaymentList | null>(null);

    constructor(
        private _httpClient: HttpClient
    ) { }

    get payment$(): Observable<IPayment | null> {
        return this._payment.asObservable();
    }

    createPayments(paymentDetails: IPayment): Observable<BaseRespone<IPayment>> {
        return this._httpClient.post<BaseRespone<IPayment>>(`${environment.baseURl}/Payment`, paymentDetails)
            .pipe(
                catchError((error) => {
                    return of(error.error);
                }),
                map((newtype) => {
                    // Return the new
                    return newtype;
                })
            )
    }

    getPendingDetails(billId: number): Observable<BaseRespone<any>> {
        const params = new HttpParams().set('BillId', billId.toString());
        return this._httpClient.get<BaseRespone<any>>(`${environment.baseURl}/Payment/GetBillPayment`, { params }).pipe(
            tap((response) => {
                this._payment.next(response.result);
            }),
            catchError((error) => {
                console.error('Error to fetching OPD by ID:', error);
                throw error;
            })
        );
    }

    getPatientPaymentHistory(billId: number) {
        return this._httpClient.get<BaseRespone<IPaymentList>>(`${environment.baseURl}/Bill/Payments/${billId}`).pipe(
            tap((response) => {
                this._paymentlist.next(response.result);
            }),
            catchError((error) => {
                console.error('Error to fetching data:', error);
                throw error;
            })
        );
    }

}